import { FilterDatePicker } from 'components';
import activityContext from '../../use-recent-activity';

export const ActivityDateFilter = () => {
  const { filterDate, handleFilterDate } = activityContext.useController();

  return <FilterDatePicker currentDate={filterDate} filterName="Filter Date" onChange={handleFilterDate} />;
};
